import { render, staticRenderFns } from "./VoyageCharterParty.vue?vue&type=template&id=4720e1c7&"
import script from "./VoyageCharterParty.vue?vue&type=script&lang=js&"
export * from "./VoyageCharterParty.vue?vue&type=script&lang=js&"
import style0 from "./VoyageCharterParty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports